import * as yup from 'yup';
import { VALIDATORS } from 'core';

export const CHANGE_PASSWORD_VALIDATION_SCHEMA = yup.object().shape({
  currentPassword: yup.string().required('Please provide old password.'),
  newPassword: VALIDATORS.password,
  confirmPassword: yup
    .string()
    .required('Please confirm password.')
    .oneOf([yup.ref('newPassword')], "Seems that you've made some typo in this field."),
});
